import React, { useContext, useEffect } from "react";
import { AuthContext } from "../AuthContext";
import DeleteIcon from "@mui/icons-material/Delete";
import AddBoxIcon from "@mui/icons-material/AddBox";
import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  Input,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  styled,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";
import NotInterestedIcon from "@mui/icons-material/NotInterested";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { red } from "@mui/material/colors";
import { useState } from "react";
import SyncIcon from "@mui/icons-material/Sync";

import { getStInstalledEquipments } from "../services/agreementServices";
import { keyNewEquipmentRows, newEquipmentRowKey } from "../utils/equipmentRowKeys";


const EquipmentsTable = ({
  selectedInvoice,
  showAction = true,
  showCheckboxes = false,
  formType,
  onAgreementUnitSizeExceed,
  dealer,
  allowedUnits,
  idType
}) => {
  const { ctxStEquipments, setCtxStEquipments, ctxEquipmentTypes, group } =
    useContext(AuthContext);
  console.log("EquipmentTable ctxStEquipment :", ctxStEquipments);
  console.log("EquipmentTable ctxStEquipmentTypes :", ctxEquipmentTypes);
  console.log("EquipmentTable group :", group);
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [previous, setPrevious] = React.useState({});
  // Drop a row's Revert snapshot, so its next edit session snapshots afresh.
  const clearPrevious = (id) => setPrevious(({ [id]: _, ...rest }) => rest);
  const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);
  const [deleteIndex, setDeleteIndex] = React.useState(-1);
  const [isBulkDelete, setIsBulkDelete] = React.useState(false);
  const [error, setError] = React.useState("");
  const [equipmentUnitSize, setEquipmentUnitSize] = useState(0);
  const [disableEqSync, setDisableEqSync] = useState(false);
  const [processMsg, setProcessMsg] = useState("");
  const isDealer = group === "jbw-dealer";
  // const [displayEqupments, setDisplayEquipments] = useState(true);

  // useEffect(() => {
  //   setDisplayEquipments(selectedInvoice.jbwAgreementId ? false : true)
  // }, [selectedInvoice.jbwAgreementId])

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.primary.mlight,
      color: theme.palette.common.black,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const handleAddEquipment = () => {
    const id = newEquipmentRowKey();
    const newObj = {
      id: id,
      manufacturer: null,
      modelNo: null,
      serialNumber: null,
      isEditMode: true,
      // Blank until Done confirms it, so Revert removes the row rather than restoring it.
      discardOnRevert: true,
      locationId: selectedInvoice?.locationId,
      installedEquipmentId: null,
      source: "JB360",
      dataReceivedFromST: 1,
      equipmentType: "new",
    };
    setCtxStEquipments((oldData) => {
      return [...oldData, newObj];
    });
    setPrevious((state) => ({ ...state, [id]: newObj }));
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const allIds = ctxStEquipments.map((equipment) => equipment.id);
      setSelectedRows(allIds);
    } else {
      setSelectedRows([]);
    }
  };

  const handleRowSelect = (id) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const handleDeleteSelected = () => {
    setIsBulkDelete(true); // Set bulk delete to true
    setOpenDeleteDialog(true);
  };

  const handleEtChange = (e, row) => {
    console.log("selected equipment type : ", e.target.value);

    if (!previous[row.id]) {
      setPrevious((state) => ({ ...state, [row.id]: row }));
    }
    console.log("On change Previous eq list :", previous);
    const value = e.target.value;
    const name = "equipmentTypeId";
    const { id } = row;
    const newRows = ctxStEquipments.map((ctsteq) => {
      if (ctsteq.id === id) {
        return { ...ctsteq, [name]: value };
      }
      return ctsteq;
    });
    setCtxStEquipments(newRows);
  };

  useEffect(() => {
    setEquipmentUnitSize(allowedUnits);
  }, [allowedUnits]);

  const handleDelete = (index) => {
    console.log("index value", index);
    setDeleteIndex(index);
    setIsBulkDelete(false);
    setOpenDeleteDialog(true);
  };

  const onChange = (e, row) => {
    if (!previous[row.id]) {
      setPrevious((state) => ({ ...state, [row.id]: row }));
    }
    console.log("On change Previous eq list :", previous);
    const value = e.target.value;
    const name = e.target.name;
    const { id } = row;
    const newRows = ctxStEquipments.map((ctsteq) => {
      if (ctsteq.id === id) {
        return { ...ctsteq, [name]: value };
      }
      return ctsteq;
    });
    setCtxStEquipments(newRows);
  };

  const onToggleEditMode = (id, action) => {
    console.log("ontoggleeditmode ctx : ", ctxStEquipments);
    const eq = ctxStEquipments.filter((row) => row.id === id);
    console.log("ontoggleeditmode  eq: ", eq.manufacturer);

    if (eq.length > 0 && !eq[0].manufacturer && action === "done") {
      setError("Manufacturer is mandatory");
      return; // Exit the function without toggling edit mode
    }

    setError("");

    if (action === "done") {
      // Done confirms the row's values. The next edit session snapshots from here, so a
      // later Revert returns to what Done confirmed rather than to an earlier session's
      // values -- or, for an added row, to the blank row handleAddEquipment snapshotted.
      clearPrevious(id);
    }

    setCtxStEquipments((state) => {
      return state.map((row) => {
        if (row.id === id) {
          return {
            ...row,
            isEditMode: !row.isEditMode,
            // A row confirmed with Done has values to revert to.
            ...(action === "done" && { discardOnRevert: false }),
          };
        }
        return row;
      });
    });
  };

  const onRevert = (id) => {
    const row = ctxStEquipments.find((row) => row.id === id);
    console.log("reverting id :", id);
    // console.log("Previous eq list :", previous);
    // console.log("Previous ctx eq list :", ctxStEquipments);
    if (row?.discardOnRevert) {
      setError("");
      // Row was added blank and never confirmed with Done: drop it instead of restoring a snapshot.
      setCtxStEquipments((oldData) => oldData.filter((row) => row.id !== id));
    } else {
      const newRows = ctxStEquipments.map((row) => {
        if (row.id === id) {
          console.log("found row id :", row.id);
          console.log("found previous id ", previous[id]);
          return previous[id] ? previous[id] : row;
        }
        return row;
      });
      //console.log("Edited eq list :", newRows);
      setCtxStEquipments(newRows);
      clearPrevious(id);

      onToggleEditMode(id);
    }
  };

  const handleDialogClose = (data) => {
    setOpenDeleteDialog(false);
    console.log("equipment delete index : ", deleteIndex);
    if (data) {
      if (isBulkDelete) {
        // Bulk delete confirmed
        setCtxStEquipments((oldData) =>
          oldData.filter((equipment) => !selectedRows.includes(equipment.id))
        );
        setSelectedRows([]); // Clear selection after deletion
      } else if (deleteIndex !== -1) {
        setCtxStEquipments((olddata) =>
          olddata.filter((f, i) => i !== deleteIndex)
        );
      }
    }
  };

  const getEquipmentTypeName = (equipment) => {
    if (equipment.equipmentTypeId === null) {
      return "N/A";
    }
    const types = ctxEquipmentTypes?.filter(
      (et) => et.id === equipment.equipmentTypeId
    );
    return types?.[0]?.equipmentType || "N/A";
  };

  const getEquipmentType = (equipmentTypeId) => {
    if (equipmentTypeId === null) {
      return 0;
    }
    const types = ctxEquipmentTypes?.filter((et) => et.id === equipmentTypeId);
    return types[0]?.id;
  };

  const handleSyncEquipment = () => {
    setError("");
    setDisableEqSync(true);
    setProcessMsg("Syncing equipments from ServiceTitan. Please wait...");
    getStInstalledEquipments(
      selectedInvoice?.id,
      selectedInvoice?.tenantId,
      selectedInvoice?.locationId,
      undefined,
      idType
    )
      .then((res) => {
        const statusCode = res.status;
        const data = res.data;
        if (statusCode === 200) {
          if (!data || (Array.isArray(data) && data.length === 0)) {
            setError("No installed equipment data received from ServiceTitan.");
            setCtxStEquipments([]);
            // setDisplayEquipments(false);
            setDisableEqSync(false);
            setProcessMsg("");
            return;
          }
          console.log("Installed Equipments from ST:", data);
          setCtxStEquipments(keyNewEquipmentRows(data));
          setDisableEqSync(true);
          //setDisplayEquipments(true);
          setProcessMsg("");
        } else {
          console.log("Unable to fetch installed equipments from ST");
          setError(data);
          setDisableEqSync(false);
          setProcessMsg("");
        }
      })
      .catch((err) => {
        console.log("Error in fetching installed equipments:", err);
        setError("Error in fetching installed equipments from ST");
        setDisableEqSync(false);
        setProcessMsg("");
      });

  };

  useEffect(() => {
    if (group !== "jbw-dealer") {
      onAgreementUnitSizeExceed(false);
      return;
    }
    onAgreementUnitSizeExceed(
      allowedUnits > 0 &&
      ctxStEquipments.length > allowedUnits
    );
  }, [ctxStEquipments.length, allowedUnits, group]);

  return (
    <Grid container spacing={1} sx={{ p: 2 }}>
      <DeleteConfirmDialog
        open={openDeleteDialog}
        onClose={handleDialogClose}
      />
      <Grid item xs={6}>
        <Typography component="subtitle1" variant="subtitle1">
          <b>Equipment</b>
        </Typography>
      </Grid>
      {showCheckboxes && dealer.crmSystem === 'ServiceTitan' && (
        <Grid item xs={6}>
          <Box display="flex" justifyContent="flex-end">
            <Typography
              variant="captionb1"
              component="subtitle1"
              align="left"
              sx={{ fontSize: "14px", mt: 1 }}
            >
              Sync Equipment from ServiceTitan
            </Typography>
            <IconButton
              sx={{ alignSelf: "center" }}
              size="medium"
              color="success"
              disabled={disableEqSync}
              onClick={handleSyncEquipment}
            >
              <SyncIcon fontSize="inherit" />
            </IconButton>
          </Box>
        </Grid>
      )}
      <Grid item xs={12}>
        <TableContainer sx={{ maxHeight: 350 }} component={Paper}>
          <Table
            sx={{ minWidth: 550 }}
            size="small"
            aria-label="JBW Agreement Equipment table"
            stickyHeader
          >
            <TableHead sx={{ fontSize: "10px" }}>
              <TableRow>
                {showCheckboxes && (
                  <StyledTableCell padding="checkbox">
                    <Checkbox
                      indeterminate={
                        selectedRows.length > 0 &&
                        selectedRows.length < ctxStEquipments.length
                      }
                      checked={
                        ctxStEquipments.length > 0 &&
                        selectedRows.length === ctxStEquipments.length
                      }
                      onChange={handleSelectAll}
                    />
                  </StyledTableCell>
                )}
                <StyledTableCell align="left">Equipment Type</StyledTableCell>
                <StyledTableCell align="left">Manufacturer</StyledTableCell>
                <StyledTableCell align="left">Model Number</StyledTableCell>
                <StyledTableCell align="left">Serial Number</StyledTableCell>
                {formType !== "confirm" && (
                  <StyledTableCell align="center">Source</StyledTableCell>
                )}
                {showAction && (
                  <StyledTableCell align="center">Actions</StyledTableCell>
                )}
              </TableRow>
            </TableHead>
            {!error && (
              <TableBody>
                {/* {displayEqupments ? */}
                {
                  ctxStEquipments.map((equipment, index) => (
                    <TableRow
                      key={equipment.id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                    >
                      {showCheckboxes && (
                        <TableCell padding="checkbox">
                          <Checkbox
                            checked={selectedRows.includes(equipment.id)}
                            onChange={() => handleRowSelect(equipment.id)}
                          />
                        </TableCell>
                      )}
                      <TableCell align="left" sx={{ width: 130, height: 40 }}>
                        {equipment.isEditMode ? (
                          <>
                            <FormControl sx={{ m: 1, width: "150px" }} size="small">
                              <InputLabel id="et-select-label">Type</InputLabel>
                              <Select
                                labelId="et-select-label"
                                id="et-select"
                                name="equipmentType"
                                value={getEquipmentType(equipment.equipmentTypeId)}
                                label="Types"
                                onChange={(e) => handleEtChange(e, equipment)}
                              >
                                <MenuItem value={0}>Select Type</MenuItem>
                                {ctxEquipmentTypes.map((et) => (
                                  <MenuItem key={et.id} value={et.id}>
                                    {et.equipmentType}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </>
                        ) : (
                          <>{getEquipmentTypeName(equipment)}</>
                        )}
                      </TableCell>
                      <CustomTableCell
                        {...{ row: equipment, name: "manufacturer", onChange }}
                      />
                      <CustomTableCell
                        {...{
                          row: equipment,
                          name: "modelNo",
                          onChange,
                        }}
                      />
                      <CustomTableCell
                        {...{ row: equipment, name: "serialNumber", onChange }}
                      />
                      {formType !== "confirm" && (
                        <TableCell align="center" sx={{ width: 60 }}>
                          {
                            ((equipment.invoiceItemId && equipment.invoiceItemId !== null) ||
                              (equipment.installedEquipmentId && equipment.installedEquipmentId !== null)) ? (
                              <Typography
                                variant="success"
                                component="subtitle1"
                                align="left"
                                sx={{ fontSize: "14px", mt: 1 }}
                              >
                                ST
                              </Typography>
                            ) : (
                              <Typography
                                variant="warning"
                                component="subtitle1"
                                align="left"
                                sx={{ fontSize: "14px", mt: 1 }}
                              >
                                {
                                  equipment.source === "JB"
                                    ? "JB" : equipment.dataReceivedFromST === 1
                                      ? "JB360"
                                      : ""}
                              </Typography>
                            )
                          }
                        </TableCell>
                      )}
                      {showAction && (
                        <TableCell align="center" sx={{ width: 60 }}>
                          {equipment.isEditMode ? (
                            <>
                              <IconButton
                                aria-label="done"
                                color="info"
                                onClick={() =>
                                  onToggleEditMode(equipment.id, "done")
                                }
                              >
                                <DoneIcon />
                              </IconButton>
                              <IconButton
                                aria-label="revert"
                                color="error"
                                disabled={ctxStEquipments.length === 0}
                                onClick={() => onRevert(equipment.id)}
                              >
                                <NotInterestedIcon />
                              </IconButton>
                            </>
                          ) : (
                            <>
                              <IconButton
                                color="error"
                                aria-label="delete"
                                onClick={(e) => handleDelete(index)}
                                disabled={selectedRows.length > 0}
                              >
                                <DeleteIcon />
                              </IconButton>
                              <IconButton
                                color="info"
                                aria-label="edit"
                                onClick={(e) => onToggleEditMode(equipment.id)}
                                disabled={selectedRows.length > 0}
                              >
                                <EditIcon />
                              </IconButton>
                            </>
                          )}
                        </TableCell>
                      )}
                    </TableRow>
                  ))}
                {/* : <TableRow></TableRow>} */}
              </TableBody>
            )}
          </Table>
          {showAction && (
            <Box display="flex" justifyContent="flex-end" sx={{ pr: "10px" }}>
              {selectedRows.length > 0 && (
                <IconButton
                  color="error"
                  onClick={handleDeleteSelected}
                  aria-label="bulk delete"
                >
                  <DeleteIcon />
                </IconButton>
              )}
              <IconButton
                color="secondary"
                variant="outlined"
                aria-label="search job"
                sx={{ mr: "4px", fontSize: "17px" }}
                disabled={
                   isDealer &&
                  showCheckboxes &&
                  allowedUnits > 0 &&
                  ctxStEquipments.length >= allowedUnits
                }
                onClick={handleAddEquipment}
              >
                <AddBoxIcon sx={{ fontSize: "20px", mr: "3px" }} />
                Add
              </IconButton>
            </Box>
          )}
        </TableContainer>
      </Grid>
      {error && (
        <Grid item xs={12} sx={{ mt: 1, display: "flex", justifyContent: "center" }}>
          <Typography
            variant="subtitle1"
            align="center"
            sx={{ fontSize: "16px" }}
            color="error"
          >
            {error}
          </Typography>
        </Grid>
      )}
      {processMsg && (
        <Grid item xs={12} sx={{ mt: 1 }}>
          <Typography
            variant="caption"
            component="subtitle1"
            align="left"
            sx={{ fontSize: "16px", mt: 1 }}
          >
            {processMsg}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

const CustomTableCell = ({ row, name, onChange }) => {
  const { isEditMode } = row;
  return (
    <TableCell align="left" sx={{ width: 130, height: 40 }}>
      {isEditMode ? (
        <Input
          value={row[name]}
          name={name}
          onChange={(e) => onChange(e, row)}
          sx={{ width: 130, height: 40 }}
        />
      ) : (
        row[name]
      )}
    </TableCell>
  );
};

const DeleteConfirmDialog = ({ open = false, onClose, title, message }) => {
  const handleClose = (event, reason) => {
    if (reason === "escapeKeyDown" || reason === "backdropClick") {
      return;
    }
    onClose(false);
  };

  return (
    <Dialog
      onClose={handleClose}
      open={open}
      PaperProps={{
        component: "div",
      }}
      fullWidth={true}
      maxWidth={"sm"}
      disableEscapeKeyDown
    >
      <DialogTitle sx={{ m: 0, p: 2 }}>
        <b>{title ? title : "Equipment Delete"}</b>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography
              variant="caption"
              align="center"
              sx={{ fontSize: "18px", color: red[900] }}
            >
              <WarningAmberIcon
                sx={{ fontSize: 50, color: red[900], mb: -1 }}
              />{" "}
              {message
                ? message
                : " Are You Sure you want delete the Equipment ?"}
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Grid container spacing={2}>
          <Grid item></Grid>
          <Box sx={{ flexGrow: 1 }} />
          <Grid item>
            <Button onClick={() => onClose(true, title)}>Yes</Button>
            <Button onClick={handleClose}>No</Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export { DeleteConfirmDialog };
export default EquipmentsTable;